import { Map } from 'features/mapping/components/Map';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useGeoEventEditMarker } from 'features/geoEvents/hooks/useGeoEventEditMarker';
import { GeoEventTypes } from '../../../../../../constants';

type WildfireMarkerProps = {
  geoEvent: Partial<Wildfire>;
  onChange: (location: { lat: number; lng: number }) => void;
  locked?: boolean;
  moveOnEvacZoneClick?: boolean;
};

export const WildfireMarker = (props: WildfireMarkerProps): JSX.Element => {
  const {
    geoEvent,
    onChange,
    locked = false,
    moveOnEvacZoneClick = false,
  } = props;
  const { markerProps } = useGeoEventEditMarker({
    geoEventType: GeoEventTypes.wildfire,
    onChange,
    disabled: locked,
    moveOnEvacZoneClick,
  });

  return (
    <Map.WildFireGeoEventMarker
      {...markerProps}
      geoEvent={geoEvent}
      draggable={!locked}
      anchor={geoEvent.data?.isComplexParent ? 'center' : 'bottom'}
    />
  );
};
